import {paylogikApi as api, ExceptionManagerListVm} from './paylogikApi';


export type GetAllManageExceptionsDataApiResponse =
    /** status 200 Success */ ExceptionManagerListVm[];
export type GetAllManageExceptionsDataApiArg = {
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    fileName?: string;

};


const injectedRtkApi = api.injectEndpoints({
endpoints: (build) => ({

getAllManageExceptionsData: build.query<
            GetAllManageExceptionsDataApiResponse,
            GetAllManageExceptionsDataApiArg
        >({
            query: (queryArg) => ({
                url: `/api/ODataManualQuery/getAllManageExceptionsData`,
                method: 'POST',
                body: queryArg.fileName,
                 headers: {
    'Content-Type': 'application/json',
},

                params: {
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
    })
})




export const {
useLazyGetAllManageExceptionsDataQuery
} = injectedRtkApi

export {injectedRtkApi as paylogikApi};